export const GET_TIME_BUCKET_CATEGORIES = 'GET_TIME_BUCKET_CATEGORIES';
export const GET_TIME_BUCKET_CATEGORIES_SUCCESS =
  'GET_TIME_BUCKET_CATEGORIES_SUCCESS';
export const GET_TIME_BUCKET_CATEGORIES_FAILURE =
  'GET_TIME_BUCKET_CATEGORIES_FAILURE';
export const GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY =
  'GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY';
export const GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY_SUCCESS =
  'GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY_SUCCESS';
export const GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY_FAILURE =
  'GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY_FAILURE';
export const GET_TIME_BUCKET_CYT = 'GET_TIME_BUCKET_CYT_FAILURE';
export const GET_TIME_BUCKET_CYT_SUCCESS = 'GET_TIME_BUCKET_CYT_SUCCESS';
export const GET_TIME_BUCKET_CYT_FAILURE = 'GET_TIME_BUCKET_CYT_FAILURE';
export const REMOVE_FROM_CATEGORIES_TO_BE_REFRESHED =
  'REMOVE_FROM_CATEGORIES_TO_BE_REFRESHED';
export const UPDATE_CATEGORIES_TO_BE_REFRESHED =
  'UPDATE_CATEGORIES_TO_BE_REFRESHED';
